import React, { useState, useEffect } from "react";
import { FullScreenWidget } from "./FullScreenDesktopWidget";
import { MinimizedAndMobileWidget } from "./MinimizedAndMobileWidget";
import { useChat } from "../contexts/ChatProvider";

export const Widget = ({remoteName = "", onSend}) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const {isMobile, setStartIndex, setMessages} = useChat();

  useEffect(() => {
    if(isMobile){
      setIsFullScreen(false);
    }
  }, [isMobile]);

  const toggleFullScreen = () => {
    setStartIndex(0);
    setMessages([]);
    setIsFullScreen(prev => !prev);
  };

  return (isMobile || !isFullScreen) ? (
    <MinimizedAndMobileWidget
      remoteName={remoteName}
      onSend={onSend}
      onScreenExpand={toggleFullScreen}
    />
  ) : (
    <FullScreenWidget
      remoteName={remoteName}
      onSend={onSend}
      onScreenMinimize={toggleFullScreen}
    />
  );
};